<template>
    <div class="tabs_content baseInfo" v-if="despInfo">
        <div class="title1">专利说明书</div>
        <div v-for="(item,index) in despInfo.split('。')" :key="index">
            <p v-if="item" class="grey_font_color">{{item}}。</p>
        </div>
    </div>
    <div class="tabs_content baseInfo" v-else>
        <div class="title1">专利说明书</div>
        <span>暂无数据</span>
        
    </div>
</template>
<script>
import {mapActions} from 'vuex'
export default {
    name:"direction",
        props:{
        pid:{
            id:''
        }
    }, 
    data(){
        return{
            despInfo:'',
        }
    },
    watch:{
     pid:{
          handler(n,o){
              console.log(n,o)
              this.getDesp(n.id)
          },
          deep:true
          
     }
    },
     created(){
         console.log(200000,this.pid)
        this.getDesp(this.pid.id)
    },
    methods:{
        ...mapActions('search',['getPatentDesp']),
        getDesp(val) {
            this.loading = true
            this.despInfo = ''
            let data = {
                params: {
                   udn: val
                }
            }
            let _this = this
            this.getPatentDesp({data: data,handle(res) {
                _this.despInfo = res.patent.description
                _this.loading = false
            }})
        },
    }
}
</script>